import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Footer from './components/Footer/Footer';
import { AuthProvider } from './context/AuthContext';
import { RolesProvider, ProtectedRoute } from './context/RoleContext';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import RequestPermission from 'pages/RequestPermission/RequestPermission';

const Home = lazy(() => import('./pages/Home/Home'));
const Report = lazy(() => import('./pages/Reports/Report'));
const FadAdmin = lazy(() => import('./pages/FadAdmin/FadAdmin'));
const FsrAdmin = lazy(() => import('./pages/FsrAdmin/FsrAdmin'));
const DefectorForm = lazy(() => import('./pages/DefectorForm/DefectorForm'));
const PaCodeForm = lazy(() => import('./pages/PaCodeForm/PaCodeForm'));
const InvoiceReportForm = lazy(() => import('./pages/InvoiceReportForm/InvoiceReportForm'));
const CustomerListingForm = lazy(() => import('./pages/CustomerListingForm/CustomerListingForm'));
const InventoryReportForm = lazy(() => import('./pages/InventoryReportForm/InventoryReportForm'));
const ActiveAndTerminatedDealerForm = lazy(() => import('./pages/ActiveAndTerminatedDealerForm/ActiveAndTerminatedDealerForm'));

const LazyComponentWrapper: React.FC<{ component: React.ComponentType<any>, props?: any }> = ({ component: Component, props }) => (
    <Component {...props} />
);

const AppContent = () => {
    return (
        <div className='max-w-screen h-screen'>
            <Navbar />
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/reports" element={<Report />} />
                    <Route path="/reports/defectors" element={<DefectorForm isDealerAccount={false} />} />
                    <Route path="reports/defectors/dealer" element={<DefectorForm isDealerAccount={true} />} />
                    <Route path='/reports/error/single/pacodes' element={<PaCodeForm EnterpriseErrorReport={false}/>}/>
                    <Route path="/reports/error/pacodes" element={<PaCodeForm EnterpriseErrorReport={true}/>}/>
                    <Route path="/reports/invoiceReport" element={<InvoiceReportForm />} />
                    <Route path="/reports/customerListingReport" element={<CustomerListingForm />} />
                    <Route path="/reports/inventoryReport" element={<InventoryReportForm />} />
                    <Route path="/reports/activeAndTerminatedDealer" element={<ActiveAndTerminatedDealerForm />} />
                    <Route path="/fadAdmin" element={<FadAdmin />} />
                   {/* <Route
                        path='/fsrAdmin/*'
                        element={
                            <ProtectedRoute
                                requiredPermission={{
                                    type: 'execute',
                                    role: 'FSR:FSRAdministrator|FSR:customer'
                                }}
                                element={<LazyComponentWrapper component={FsrAdmin} />}
                                fallback={<RequestPermission />}
                            />
                        }
                    /> */}

                    <Route path="/unauthorized" element={<RequestPermission />} />
                </Routes>
            </Suspense>
            <Footer />
        </div>
    );
};

const App = () => {

    return (



        <AuthProvider>
            <AuthenticatedTemplate>
                <RolesProvider>
                    <AppContent />
                </RolesProvider>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <div>Please sign in to access the application.</div>
            </UnauthenticatedTemplate>
        </AuthProvider>
    );
};

export default App;
